/**
 * Buyer analytics event → category map — leaf module (no imports).
 */

export const EVENT_CATEGORY_MAP = {
  page_view: "page_view",
  page_viewed: "page_view",
  search_performed: "search",
  search_results_viewed: "search",
  search_no_results: "search",
  search_sort_changed: "search",
  search_pagination_clicked: "search",
  search_result_card_clicked: "search",
  search_filter_changed: "filter",
  vehicle_detail_viewed: "listing_engagement",
  vehicle_photo_gallery_opened: "listing_engagement",
  vehicle_photo_changed: "listing_engagement",
  vehicle_fair_price_viewed: "fair_price",
  vehicle_risk_panel_viewed: "risk",
  vehicle_checklist_opened: "checklist",
  vehicle_saved: "save",
  vehicle_unsaved: "save",
  buyer_account_viewed: "page_view",
  buyer_likes_viewed: "save",
  buyer_guest_merge_started: "save",
  buyer_guest_merge_completed: "save",
  buyer_guest_merge_failed: "save",
  buyer_preferences_viewed: "save",
  automap_currency_changed: "filter",
  automap_fx_snapshot_viewed: "page_view",
  buyer_financing_prefs_saved: "save",
  buyer_quiz_intent_saved: "save",
  buyer_profile_merge_applied: "save",
  buyer_payment_estimate_viewed: "save",
  buyer_payment_preferences_edit_clicked: "save",
  vehicle_detail_payment_estimate_viewed: "listing_engagement",
  vehicle_compare_added: "compare",
  vehicle_compare_removed: "compare",
  vehicle_compare_opened: "compare",
  vehicle_compare_cleared: "compare",
  vehicle_compare_detail_clicked: "compare",
  dealer_profile_viewed: "dealer_engagement",
  dealer_directory_viewed: "dealer_engagement",
  dealer_contact_clicked: "dealer_engagement",
  dealer_whatsapp_clicked: "dealer_engagement",
  quiz_started: "quiz",
  quiz_step_viewed: "quiz",
  quiz_step_completed: "quiz",
  quiz_completed: "quiz",
  quiz_abandoned: "quiz",
  quiz_results_viewed: "quiz",
  quiz_lead_submitted: "quiz",
  recommendation_results_viewed: "recommendation",
  recommendation_card_clicked: "recommendation",
  recommendation_contact_clicked: "recommendation",
  buyer_checklist_page_viewed: "checklist",
  buyer_checklist_item_checked: "checklist",
  buyer_checklist_completed: "checklist",
  whatsapp_contact_clicked: "contact",
  lead_form_opened: "contact",
  lead_form_submitted: "contact",
  lead_created: "lead",
  contact_modal_opened: "contact",
  seo_page_viewed: "seo",
  seo_inventory_card_clicked: "seo",
  guide_page_viewed: "guide",
  guide_cta_clicked: "guide",
  widget_opened: "contact",
  widget_closed: "contact",
  vehicle_context_attached: "contact",
  intake_started: "lead",
  intake_step_completed: "lead",
  intake_completed: "lead",
  lead_submit_started: "lead",
  lead_submit_succeeded: "lead",
  lead_submit_failed: "lead",
  broker_submit_started: "lead",
  broker_submit_succeeded: "lead",
  broker_submit_failed: "lead",
  continue_whatsapp_clicked: "contact",
  status_viewed: "lead",
  status_refreshed: "lead",
  draft_restored: "lead",
  draft_cleared: "lead",
  chat_thread_created: "lead",
  chat_thread_resumed: "lead",
  chat_message_created: "lead",
  chat_message_failed: "lead",
  whatsapp_message_received: "lead",
  whatsapp_message_matched_to_thread: "lead",
  whatsapp_message_unmatched: "lead",
  whatsapp_message_status_updated: "lead",
  bot_intake_started: "lead",
  bot_field_requested: "lead",
  bot_field_captured: "lead",
  bot_parse_failed: "lead",
  bot_review_ready: "lead",
  bot_submission_triggered: "lead",
  bot_submission_succeeded: "lead",
  bot_submission_failed: "lead",
  bot_fallback_to_form: "lead",
  automapa_whatsapp_widget_viewed: "contact",
  automapa_whatsapp_consent_accepted: "lead",
  automapa_whatsapp_intake_submitted: "lead",
  automapa_whatsapp_lead_created: "lead",
  automapa_whatsapp_broker_submitted: "lead",
  automapa_whatsapp_bot_started: "lead",
  automapa_whatsapp_bot_completed: "lead",
  automapa_whatsapp_message_sent: "lead",
  automapa_whatsapp_message_received: "lead",
  automapa_whatsapp_thread_created: "lead",
  automapa_whatsapp_error: "lead",
  automapa_whatsapp_widget_fallback_wa_me: "contact",
  automapa_whatsapp_feature_gated: "contact",
  geolocation_requested: "geolocation",
  geolocation_granted: "geolocation",
  geolocation_denied: "geolocation",
  geolocation_unavailable: "geolocation",
};

export function resolveEventCategory(eventName) {
  return EVENT_CATEGORY_MAP[eventName] || "other";
}
